// @ts-strict-ignore
import {Component, Input, OnInit, SimpleChanges} from "@angular/core";

export enum BatteryLevel {
	full = 0,
	threequarters = 1,
	half = 2,
	quarter = 3,
	empty = 4,
	unavailable = 5,
}

export type BatteryLevelIcon =
	| "fa-battery-slash"
	| "fa-battery-empty"
	| "fa-battery-quarter"
	| "fa-battery-half"
	| "fa-battery-three-quarters"
	| "fa-battery-full";

export abstract class BatteryLevelHelper {
	private static readonly batteryLevels: number[] = [90, 70, 40, 20, 0];

	public static getBatteryLevel(batteryPercent: number): BatteryLevel {
		let newBatteryLevel = BatteryLevel.unavailable;
		let currentCheckIndex = 0;
		while (currentCheckIndex < BatteryLevelHelper.batteryLevels.length) {
			if (batteryPercent >= BatteryLevelHelper.batteryLevels[currentCheckIndex]) {
				newBatteryLevel = <BatteryLevel>currentCheckIndex;
				break;
			}
			currentCheckIndex++;
		}

		return newBatteryLevel;
	}

	public static getBatteryLevelIcon(level: BatteryLevel): BatteryLevelIcon {
		switch (level) {
			case BatteryLevel.full:
				return "fa-battery-full";
			case BatteryLevel.threequarters:
				return "fa-battery-three-quarters";
			case BatteryLevel.half:
				return "fa-battery-half";
			case BatteryLevel.quarter:
				return "fa-battery-quarter";
			case BatteryLevel.empty:
				return "fa-battery-empty";
			case BatteryLevel.unavailable:
				return "fa-battery-slash";
		}
	}
}

@Component({
	selector: "sim-battery-status-icon",
	templateUrl: "./battery-status-icon.component.html",
	styleUrls: ["./battery-status-icon.component.scss"],
	standalone: false,
})
export class BatteryStatusIconComponent implements OnInit {
	@Input() currentPercent: number;
	@Input() fontSize: string = null;

	batteryLevel: BatteryLevel = BatteryLevel.unavailable;
	batteryLevelIcon: BatteryLevelIcon = "fa-battery-slash";

	constructor() {}

	ngOnInit(): void {
		this.setBatteryLevel();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes["currentPercent"]) {
			this.setBatteryLevel();
		}
	}

	private setBatteryLevel() {
		this.batteryLevel = BatteryLevelHelper.getBatteryLevel(this.currentPercent);
		this.batteryLevelIcon = BatteryLevelHelper.getBatteryLevelIcon(this.batteryLevel);
	}
}
